import * as React from 'react';
import { Box, Grid, List, TablePagination, Typography } from '@mui/material';
import { AnnouncementOutlined } from '@mui/icons-material';

import { EBuildingListDisplayMode } from 'enums';
import { IBuildingItem } from 'models';
import { BuildingItemGridMode, BuildingItemListMode } from '.';

interface BuildingListProps {
  buildings: Array<IBuildingItem>;
  selectedBuildingId?: number;
  mode?: string;
  onBuildingItem?: (buildingId: number) => void;
}

export const BuildingList: React.FC<BuildingListProps> = (props) => {
  const { buildings, selectedBuildingId, mode = EBuildingListDisplayMode.GRID, onBuildingItem } = props;
  const [rowsPerPage, setRowsPerPage] = React.useState<number>(12);
  const [page, setPage] = React.useState(0);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedBuildings = buildings.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  if (buildings.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', paddingY: 4 }}>
        <AnnouncementOutlined color="primary" sx={{ fontSize: 40 }} />
        <Typography color="textSecondary">No building!</Typography>
      </Box>
    );
  }

  return (
    <>
      {mode === EBuildingListDisplayMode.LIST ? (
        <List component="nav">
          {paginatedBuildings.map((building) => (
            <BuildingItemListMode
              key={`building-${building.id}`}
              building={building}
              selected={building.id === selectedBuildingId}
              onBuildingItem={onBuildingItem}
            />
          ))}
        </List>
      ) : (
        <Grid container spacing={4}>
          {paginatedBuildings.map((building) => (
            <Grid key={`building-${building.id}`} item xs={12} md={6} lg={4} xl={3}>
              <BuildingItemGridMode building={building} onBuildingItem={onBuildingItem} />
            </Grid>
          ))}
        </Grid>
      )}

      <Box sx={{ paddingTop: 3, display: 'flex', justifyContent: 'center' }}>
        <TablePagination
          rowsPerPageOptions={[
            {
              value: 12,
              label: '12',
            },
            {
              value: 24,
              label: '24',
            },
            {
              value: 48,
              label: '48',
            },
            {
              value: 96,
              label: '96',
            },
          ]}
          component="div"
          count={buildings.length}
          rowsPerPage={rowsPerPage}
          page={page}
          labelRowsPerPage={'Items per Page'}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
    </>
  );
};
